module.exports = __webpack_public_path__ + "static/flags/PO-22ce0d5130a168d226810e61c836a10b.gif";